import cn from 'classnames'
import type { ReactNode } from 'react'

import { QualityGauge } from 'partner360/components/qualityIndicator'

import { formatCockpitScore } from '../../../lib'

import styles from './CockpitCollapsedSummary.module.scss'

interface ICockpitCollapsedSummaryProps {
  children: ReactNode
  quality: number | null
  qualityLabel: ReactNode
  qualityTitle?: string
  /** Opens what stands behind the score: the label becomes a link to it, underlined. */
  onQualityClick?: () => void
  /** `false` drops the Plan Quality column with its divider, and the metrics take the width. */
  showQuality?: boolean
}

export const CockpitCollapsedSummary = ({
  children,
  quality,
  qualityLabel,
  qualityTitle,
  onQualityClick,
  showQuality = true,
}: ICockpitCollapsedSummaryProps) => {
  return (
    <section className={styles.root}>
      <div className={cn(styles.metrics, { [styles.metricsWithQuality]: showQuality })}>
        {children}
      </div>
      {showQuality && (
        <>
          <span className={styles.divider} aria-hidden />
          <div className={styles.quality}>
            {onQualityClick ? (
              <button
                type="button"
                className={cn(styles.qualityLabel, styles.qualityLink)}
                title={qualityTitle}
                onClick={onQualityClick}
              >
                {qualityLabel}
              </button>
            ) : (
              <span className={styles.qualityLabel} title={qualityTitle}>
                {qualityLabel}
              </span>
            )}
            <span className={styles.qualityValue}>
              <QualityGauge score={quality} height={30} />
              <span className={styles.qualityScore}>{formatCockpitScore(quality)}</span>
            </span>
          </div>
        </>
      )}
    </section>
  )
}

CockpitCollapsedSummary.displayName = 'CockpitCollapsedSummary'
